import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取民族列表
  static getNationList(params) {
    return request({
      url: `basic/nation/list`,
      host: config.HOST_MALL,
      params
    });
  }

  // 民族加校验
  static nationValidate(params) {
    return request({
      url: `valetOpenCard/queryCardTypeWithNation?healthConsultantNum=${params.healthConsultantNum}&nation=${params.nation}`,
      host: config.HOST_STORE,
      method: 'post_json'
    });
  }

  // 获取银行总行列表
  static getHeadBankList() {
    return request({
      url: `basic/bank/query/enable/headBank`,
      host: config.HOST_MALL
    });
  }

  // 获取银行支行列表
  static getBranchBankList(params) {
    return request({
      url: `basic/bank/query/bankBranch`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 获取指定卡号的用户姓名
  static getMemberName(params) {
    return request({
      url: `user/info/getMemberName`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  // 获取本人注册时所填写的健康顾问
  static getHealthyUser() {
    return request({
      url: `user/info/getUserInfo`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  // 获取指定卡号的用户信息
  static getMemberInfo(params) {
    return request({
      url: `user/info/getMemberInfo`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  /**
   * 提交开店信息
   */
  static submitStoreMsg(params) {
    return request({
      url: `store/create/check_store_info`,
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 更新健康顾问
   */
  static submitStoreUpdateHealthnum(params) {
    return request({
      url: `store/info/unRegisterMemberUpdateHealthNum`,
      host: config.HOST_STORE,
      method: 'post_json',
      params
    });
  }

  /**
   * 提交工作室信息
   */
  static submitStudioMsg(params) {
    return request({
      url: `store/create/check_member_info`,
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/StoreCardMsg/StoreCardMsgServ.js